// mkb codes in our diagnoses can be typed with cyrillic look-alike letters (e.g. "К02.1"), egisz uses latin ones
const normalizeMKBCode = (code) => {
	const cyrillicToLatin = { 'А': 'A', 'В': 'B', 'Е': 'E', 'К': 'K', 'М': 'M', 'Н': 'H', 'О': 'O', 'Р': 'P', 'С': 'C', 'Т': 'T', 'У': 'Y', 'Х': 'X' }
	return (code || '').trim().toUpperCase().split('').map(ch => cyrillicToLatin[ch] || ch).join('')
}

// finds the egisz MKB dictionary option ({ mkb_code, title }) for a code,
// with the same fallback as EGISZRecord::ensureMKBExists() on the backend: K02.10 -> K02.1 -> K02
const findEGISZMKBOption = (options, mkbCode) => {
	let code = normalizeMKBCode(mkbCode)
	while(code.length >= 3) {
		const option = options.find(o => o.mkb_code === code)
		if(option) return option
		code = code.slice(0, -1)
	}
	return null
}

export {
	normalizeMKBCode,
	findEGISZMKBOption
}
